import {createAction, props} from '@ngrx/store';
import {UUID} from '../../shared/types/uuid.type';
import {
  CreateStreamTranscodingConfigurationDto,
  StreamTranscodingConfiguration,
  UpdateStreamTranscodingConfigurationDto
} from '../../services/api/stream-transcoding-configurations';

const ACTION_PREFIX = '[Stream Transcoding Configurations]';

// Load All
export const loadStreamTranscodingConfigurations = createAction(
  `${ACTION_PREFIX} Load All`
);

export const loadStreamTranscodingConfigurationsSuccess = createAction(
  `${ACTION_PREFIX} Load All Success`,
  props<{ items: StreamTranscodingConfiguration[] }>()
);

export const loadStreamTranscodingConfigurationsFailure = createAction(
  `${ACTION_PREFIX} Load All Failure`,
  props<{ error: string }>()
);

// Create
export const createStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Create`,
  props<{ dto: CreateStreamTranscodingConfigurationDto }>()
);

export const createStreamTranscodingConfigurationSuccess = createAction(
  `${ACTION_PREFIX} Create Success`,
  props<{ item: StreamTranscodingConfiguration }>()
);

export const createStreamTranscodingConfigurationFailure = createAction(
  `${ACTION_PREFIX} Create Failure`,
  props<{ error: string }>()
);

// Update
export const updateStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Update`,
  props<{ id: UUID; dto: UpdateStreamTranscodingConfigurationDto }>()
);

export const updateStreamTranscodingConfigurationSuccess = createAction(
  `${ACTION_PREFIX} Update Success`,
  props<{ item: StreamTranscodingConfiguration }>()
);

export const updateStreamTranscodingConfigurationFailure = createAction(
  `${ACTION_PREFIX} Update Failure`,
  props<{ id: UUID; error: string }>()
);

// Resume
export const resumeStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Resume`,
  props<{ id: UUID }>()
);

export const resumeStreamTranscodingConfigurationSuccess = createAction(
  `${ACTION_PREFIX} Resume Success`,
  props<{ item: StreamTranscodingConfiguration }>()
);

export const resumeStreamTranscodingConfigurationFailure = createAction(
  `${ACTION_PREFIX} Resume Failure`,
  props<{ id: UUID; error: string }>()
);

// Stop
export const stopStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Stop`,
  props<{ id: UUID }>()
);

export const stopStreamTranscodingConfigurationSuccess = createAction(
  `${ACTION_PREFIX} Stop Success`,
  props<{ item: StreamTranscodingConfiguration }>()
);

export const stopStreamTranscodingConfigurationFailure = createAction(
  `${ACTION_PREFIX} Stop Failure`,
  props<{ id: UUID; error: string }>()
);

// Delete
export const deleteStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Delete`,
  props<{ id: UUID }>()
);

export const deleteStreamTranscodingConfigurationSuccess = createAction(
  `${ACTION_PREFIX} Delete Success`,
  props<{ id: UUID }>()
);

export const deleteStreamTranscodingConfigurationFailure = createAction(
  `${ACTION_PREFIX} Delete Failure`,
  props<{ id: UUID; error: string }>()
);

// UI Helpers
export const selectStreamTranscodingConfiguration = createAction(
  `${ACTION_PREFIX} Select`,
  props<{ id: UUID | null }>()
);

export const clearStreamTranscodingConfigurationErrors = createAction(
  `${ACTION_PREFIX} Clear Errors`
);

export const resetStreamTranscodingConfigurationsState = createAction(
  `${ACTION_PREFIX} Reset State`
);
